import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ManufacturerLayer from "../components/ManufacturerLayer";

const ManufacturerPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Manufactures' />

        {/* ManufacturerLayer */}
        <ManufacturerLayer />
      </MasterLayout>
    </>
  );
};

export default ManufacturerPage;